import React from 'react'

const dataConstant = {
  KendoFilter: {
    take: 100,
    skip: 0,
    filterable: true,
    sortable: true,
    pageable: {
      pageSize: 100,
      buttonCount: 4,
      pageSizes: [5, 10, 20, 50, 100],
    },
    resizable: true,
    reorderable: true,
  },
  KendoFilterOption: {
    lessThanOrEqual: 'lte',
    greaterThanOrEqual: 'gte',
    equal: 'eq',
  },
  InventroyFileType: { PDF: 'PDF' },
  SupportedFileType: [
    {
      label: '.pdf',
      value: '.pdf',
    },
    {
      label: '.doc',
      value: '.doc',
    },
    {
      label: '.xl',
      value: '.xl',
    },
    {
      label: '.jpg',
      value: '.jpg',
    },
    {
      label: '.png',
      value: '.png',
    },
  ],
  Roles: [
    {
      label: 'Admin',
      value: 'Admin',
      key: 'Admin',
      component: <div>Coming soon..</div>,
    },
  ],
  Add: 'Add',
  Update: 'Update',
  Close: 'Close',
  Error: 'Error',
  SiteName: 'Admin',
  ToastNotificationTimeOut: 4000,
  AddFormTitle: 'Add',
  EditFormTitle: 'Edit',
  AdminInvoice: 'Admin',
  APIResponseStatus: {
    Success: 'Success',
    Failure: 'Failure',
    Warning: 'Warning',
    Undefined: 'undefined',
  },
  Undefined: undefined,
  KendoTextBoxFormat: {
    NumericTextBoxFormatN0: 'n0',
    NumericTextBoxFormatN2: 'n2',
    NumericTextBoxFormatN4: 'n4',
    NumericTextBoxFormatC2: 'c2',
    NumericTextBoxFormatP: 'p',
  },
  NumericFixedDigit: 2,
  // UserProfile: {
  //  ProfilePicFileTypes: ['image/jpeg', 'image/png', 'image/jpg'],
  //  ProfilePicSize: 2097152,
  //  ProfilePicDefaultUrl: 'resources/images/NoImage.png',
  //  imgExtensions: ['jpg', 'jpeg', 'png'],
  // },

  RoleType: {
    Client: 'Client',
    RetailCustomer: 'RetailCustomer',
    Affiliate: 'Affiliate',
    Ambassador: 'Consultant',
  },
  Upload: 'Upload',
  TwoFactorProvider: [{ label: 'Email', value: 'Email' }],
  TwoFactorProviderObj: {
    Email: 'Email',
    SMS: 'SMS',
  },
  LayoutType: [
    {
      label: 'Full Width',
      value: 'Full Width',
    },
    {
      label: 'Half Width',
      value: 'Half Width',
    },
  ],
  LayoutTypeObject: {
    FullWidth: 'Full Width',
    HalfWidth: 'Half Width',
  },
  PersonalizeImageSize: {
    FullWidth: '935 * 420',
    HalfWidth: '460 * 360',
  },
  OrderButton: {
    SaveAsDraft: 'saveAsDraft',
    CancelledOrder: 'cancelledOrder',
    RefundOrder: 'refundOrder',
  },
  OrderStatus: {
    Draft: 'Draft',
    Paid: 'Paid',
    Canceled: 'Canceled',
    Refunded: 'Refunded',
    Pending: 'Pending',
  },
  iWalletStatus: {
    Pending: 'Pending',
    Deleted: 'Deleted',
    Active: 'Active',
  },
  TransactionType: {
    Retail: 'Retail',
    Commission: 'Commission',
  },
  PersonalizeImageResolution: {
    FullWidth: 935,
    FullHeight: 420,

    HalfWidth: 460,
    HalfHeight: 360,
  },
  MediaType: {
    Image: 'Image',
    Video: 'Video',
    NormalVideo: 'Normal Video',
    YoutubeVimeoVideo: 'Youtube/Vimeo Video',
  },
  NoImageURL: '/resources/images/NoImage.png',
  NoVideoURL: '/resources/video/NoVideoURL',
  PDFImageURL: '/resources/images/pdf.png',
  ConfirmationActionButton: {
    Yes: 'Yes',
    No: 'No',
    Close: 'Close',
  },
  AddressConfirmationActionButton: {
    Confirm: 'Confirm',
    Cancel: 'Cancel',
  },
  ConfirmationTitle: 'Confirmation',
  EmailAccountType: {
    Auto: 'Auto',
    Manual: 'Manual',
  },
  StockLedgerType: {
    OpeningStock: 'OpeningStock',
    Adjustment: 'Adjustment',
  },
  MediaInformationType: {
    TextBlog: 'TextBlog',
    YouTubeVideo: 'YouTube Video',
    VimeoVideo: 'Vimeo Video',
    Picture: 'Picture',
    PDFFileUpload: 'PDF File Upload',
  },
  orderDet: {
    orderDate: 'orderDate',
    orderEntryDate: 'orderEntryDate',
    billingFirstName: 'billingFirstName',
    billingLastName: 'billingLastName',
    billingPhone: 'billingPhone',
    billingMobile: 'billingMobile',
    billingAddress1: 'billingAddress1',
    billingAddress2: 'billingAddress2',
    billingCity: 'billingCity',
    billingZipcode: 'billingZipcode',
    shippingFirstName: 'shippingFirstName',
    shippingLastName: 'shippingLastName',
    shippingPhone: 'shippingPhone',
    shippingMobile: 'shippingMobile',
    shippingAddress1: 'shippingAddress1',
    shippingAddress2: 'shippingAddress2',
    shippingCity: 'shippingCity',
    shippingZipcode: 'shippingZipcode',
    orderMessage: 'orderMessage',
  },
  giftCardDet: {
    giftCardDate: 'giftCardDate',
    giftCardName: 'giftCardName',
    acctId: 'acctId',
    originalAmount: 'originalAmount',
    giftCardType: 'giftCardType',
    giftCardMessage: 'giftCardMessage',
  },
  ItemPackage: {
    KitItemID: 'KitItemID',
    Quantity: 'Quantity',
  },
  OrderItem: {
    ItemId: 'itemid',
    Quantity: 'quantity',
    Discount: 'discount',
    UnitCost: 'unitcost',
  },
  PaymentMethodId: 'PaymentMethodId',
  // ItemId: 'ItemId',
  EmailRegex: new RegExp(/\S+@\S+\.\S+/),
  NoSpecialCharacterRegex: new RegExp(/^[0-9a-zA-Z\ ]+$/),
  NoSpecialCharacterWithWhiteSpaceRegex: new RegExp(/^[0-9a-zA-Z]*$/),
  PasswordValidation: new RegExp('((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{4,20})'),
  WhiteSpaceRegex: new RegExp(/\s/),
  OnlyNumber: new RegExp(/^[0-9]+$/),
  OnlyNumberAndDot: new RegExp(/^[0-9.]+$/),
  IPAddressRegex: new RegExp(
    /^(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  ),
  Percentage: new RegExp(/^[0-9]+(\.[0-9]{1,2})?$/),
  TwoDecimalDigit: new RegExp('^-?[0-9]+(?:.[0-9]{1,2})?$'),
  NumberAndNull: new RegExp('^(null|\\d+(\\.\\d+)?)$'),
  PhoneFieldNumbersRegex: new RegExp(/^[0-9()\-\s]+$/),
  imgExtensions: ['.jpg', '.jpeg', '.png'],
  videoExtensions: ['.mp4', '.avi', '.mov', '.wmv', '.webm'],
  inventoryFileExtension: [
    '.jpg',
    '.jpeg',
    '.png',
    '.pdf',
    '.mp4',
    '.avi',
    '.mov',
    '.wmv',
    '.webm',
  ],
  imgExtensionsWithOutDots: ['jpg', 'jpeg', 'png'],
  videoExtensionsWithOutDots: ['mp4', 'avi', 'mov', 'wmv', 'webm'],
  PDFExtensions: ['.pdf'],
  PDFExtensionWithOutDots: ['pdf'],
  FileSize: 2097152,
  MaxFileSize: 50 * 1024 * 1024,
  All: 'All',
  ZeroValue: 0,
  MinusOneValue: -1,
  DateFormatArray: [
    'MM/DD/YYYY', // 01. 12/30/2020
    '{0:MM/dd/yyyy}', // 02. 12/30/2020
    'MM/DD/YYYY HH:mm:ss', // 03. 12/30/2020 15:12:20
    '{0:MM/dd/yyyy HH:mm:ss}',
    '{0:d}',
    'YYYY-MM-DD',
    'MM/DD/YYYY hh:mm A',
  ],
  AESEncryptDecryptKey: `${process.env.REACT_APP_AES_ENCRYPT_DECRYPT_KEY}`,
  setTimeOutTime: 4000,
  TransactionMerchant: {
    AccountType: 'AccountType',
    MerchantType: 'MerchantType',
  },
  AccountType: ['Sandbox', 'Live'],
  Active: ['Yes', 'No'],
  Visible: ['Yes', 'No'],
  ItemStatus: ['Active', 'InActive'],
  ExternalPaymentApproval: ['No Approval Required', 'Required Approval'],
  OrderStatusList: ['Canceled', 'Draft', 'Paid', 'Pending', 'Refunded'],
  MembershipInvoiceStatusList: ['Active', 'InActive', 'Canceled', 'Paid', 'Pending'],
  MembershipInvoiceStatusDeleted: 'Deleted',
  Membership: {
    FeaturedItems: 'Featured Membership',
    CustomItems: 'Custom Membership',
  },
  MinMaxLength: {
    CharLimit2: 2,
    CharLimit10: 10,
    CharLimit15: 15,
    CharLimit20: 20,
    CharLimit25: 25,
    CharLimit50: 50,
    CharLimit100: 100,
    CharLimit150: 150,
    CharLimit200: 200,
    CharLimit250: 250,
    CharLimit256: 256,
    CharLimit500: 500,
    CharLimit1000: 100,
    DecimalLimit5_2: 999.99,
    DecimalLimit18_7: 9999999999.99,
    MaxPortSize: 65535,
    MaxQuantity: 999999999,
    MinValue: 0,
    MaxPoints: 9999999999,
    ZipcodeMax: 25,
    ZipcodeMin: 0,
    CreditMax: 9999999999,
    DebitMax: 9999999999,
    MaxExpirationCount: 99999,
    IntMaxValue: 2147483647,
  },
  SearchDelayInterval: 600,
  OrderThroughAdmin: 'Admin',
  ItemType: {
    AdditionalItem: 'Additional Item',
    FeaturedMembershipItem: 'Featured Membership',
    CustomMembership: 'Custom Membership',
    Autoship: 'Autoship',
  },
  UserRoleType: {
    Admin: 'admin',
    Customer: 'customer',
  },
  PlacementLeg: [
    {
      label: 'L',
      value: 'L',
    },
    {
      label: 'R',
      value: 'R',
    },
  ],
  PlacementLegPreference: [
    // {
    //   label: 'Holding Tank',
    //   value: 'H',
    // },
    {
      label: 'Alternate L-R Legs',
      value: 'A',
    },
    {
      label: 'Place on Left Leg',
      value: 'L',
    },
    {
      label: 'Place on Right Leg',
      value: 'R',
    },
  ],
  RoleTypeList: [
    {
      label: 'Admin',
      value: 'Admin',
    },
    {
      label: 'Customer',
      value: 'Customer',
    },
  ],
  CurrencyTypeUSD: 'USD',
  DefaultFreeShippingDiscountTypeList: [
    { value: null, label: 'Select discount type' },
    { value: 'PercentageDiscount', label: 'Percentage Discount' },
    { value: 'DollarOff', label: 'Dollar Off' },
    // { value: 'FixedShipping', label: 'Fixed Shipping' },
  ],
  DiscountType: {
    PercentageDiscount: 'PercentageDiscount',
    DollarOff: 'DollarOff',
    FixedShipping: 'FixedShipping',
  },
  DefaultGiftCardSentList: [
    { value: null, label: 'Select gift card sent' },
    { value: 'Customer', label: 'Customer' },
    { value: 'Sponsor', label: 'Sponsor' },
    { value: 'Both', label: 'Both' },
  ],
  DefaultDiscountTypeList: [
    { value: null, label: 'Select discount type' },
    { value: 'PercentageDiscount', label: 'Percentage Discount' },
    { value: 'DollarOff', label: 'Dollar Off' },
  ],
  DefaultDiscountApplyOnList: [
    { value: null, label: 'Select discount applied on' },
    { value: 'AppliedToSubtotal', label: 'Applied to subtotal' },
    { value: 'AppliedToOrderTotal', label: 'Applied to order total' },
  ],
  DiscountLevel: {
    ItemLevel: 'ItemLevel',
    OrderLevel: 'OrderLevel',
  },
  DefaultDiscountLevelList: [
    { value: null, label: 'Please select how to apply discount' },
    { value: 'ItemLevel', label: 'Apply discount on item level' },
    { value: 'OrderLevel', label: 'Apply discount on order level' },
  ],
  AllDropDown: {
    CoutryDropDown: 'CoutryDropDown',
    CommissionTypeDropDown: 'CommissionTypeDropDown',
    RoleDropDown: 'RoleDropDown',
    CurrencyDropDown: 'CurrencyDropDown',
    TimeZoneDropDown: 'TimeZoneDropDown',
    CustomerTypesDropDown: 'CustomerTypesDropDown',
    EmailTemplateTagDropDown: 'EmailTemplateTagDropDown',
    ItemAttributeDropDown: 'ItemAttributeDropDown',
    ItemCategoryDropDown: 'ItemCategoryDropDown',
    ItemDropDown: 'ItemDropDown',
    ItemSubTypesDropDown: 'ItemSubTypesDropDown',
    ItemIngredientDropDown: 'ItemIngredientDropDown',
    ItemFeaturesDropDown: 'ItemFeaturesDropDown',
    ItemListByItemSubTypeDropDown: 'ItemListByItemSubTypeDropDown',
    ItemTypesDropDown: 'ItemTypesDropDown',
    LanguageDropDown: 'LanguageDropDown',
    TemplateTypeDropDown: 'TemplateTypeDropDown',
    MediaCategoriesDropDown: 'MediaCategoriesDropDown',
    MediaPageDropDown: 'MediaPageDropDown',
    PaymentMethodDropDown: 'PaymentMethodDropDown',
    QualificationDropDown: 'QualificationDropDown',
    RankDropDown: 'RankDropDown',
    ShippingMethodDropDown: 'ShippingMethodDropDown',
    UserDropDown: 'UserDropDown',
    PromoActionDropDown: 'PromoActionDropDown',
    PromoEventDropDown: 'PromoEventDropDown',
    BackOfficeParentMenuDropDown: 'BackOfficeParentMenuDropDown',
    MediaPageNameDropDown: 'MediaPageNameDropDown',
    AdminParentMenuDropDown: 'AdminParentMenuDropDown',
    AutomatedEmailTypeDropDown: 'AutomatedEmailTypeDropDown',
    AutomatedEmailTriggerDropDown: 'AutomatedEmailTriggerDropDown',
    EmailTemplateDropDown: 'EmailTemplateDropDown',
    CampaignDropDown: 'CampaignDropDown',
    TemplateCategoryDropDown: 'TemplateCategoryDropDown',
    TemplateTagDropDown: 'TemplateTagDropDown',
  },
  MembershipInvoiceStatus: [
    {
      value: 'Active',
      label: 'Active',
    },
    {
      value: 'InActive',
      label: 'InActive',
    },
  ],
  RegistrationType: {
    Personal: 'Personal',
    Company: 'Company',
  },
  NumberFormat: '{0:c2}',
  PointFormat: '{0:n2}',
  SelectiWalletStatus: 'Select status',
  SelectType: 'Select Type',
  SelectCommission: 'Select commission',
  YesNoBadgeClass: [
    {
      Yes: {
        class: 'outline-badge-success',
      },
      No: {
        class: 'outline-badge-danger',
      },
    },
  ],
  ActivePendingBadgeClass: [
    {
      Active: {
        class: 'outline-badge-success',
      },
      Pending: {
        class: 'outline-badge-primary',
      },
      InActive: {
        class: 'outline-badge-warning',
      },
      Deleted: {
        class: 'outline-badge-danger',
      },
    },
  ],
  InventoryBadgeClass: [
    {
      Active: {
        class: 'outline-badge-success',
      },
      InActive: {
        class: 'outline-badge-danger',
      },
    },
  ],
  OrderBadgeClass: [
    {
      Draft: {
        class: 'outline-badge-info',
      },
      Refunded: {
        class: 'outline-badge-warning',
      },
      Cancelled: {
        class: 'outline-badge-danger',
      },
      Canceled: {
        class: 'outline-badge-danger',
      },
      Pending: {
        class: 'outline-badge-primary',
      },
      Paid: {
        class: 'outline-badge-success',
      },
      Deleted: {
        class: 'outline-badge-danger',
      },
    },
  ],
  MembershipInvoiceBadgeClass: [
    {
      Active: {
        class: 'outline-badge-success',
      },
      InActive: {
        class: 'outline-badge-danger',
      },
      Canceled: {
        class: 'outline-badge-warning',
      },
      Pending: {
        class: 'outline-badge-primary',
      },
      Paid: {
        class: 'outline-badge-success',
      },
      Deleted: {
        class: 'outline-badge-danger',
      },
    },
  ],
  PDF: 'pdf',
  SupportDataType: {
    AdminNoteType: 'AdminNoteType',
    AdminNoteStatus: 'AdminNoteStatus',
    PromotionCode: 'PromotionCode',
    Period: 'AutomatedEmailPeriod',
    BeforeAfter: 'AutomatedEmailBeforeAfter',
    LeadStatus: 'LeadStatus',
    ProjectStatus: 'ProjectStatus',
  },
  UniLevelStatus: [
    {
      label: 'Active',
      value: 'Active',
    },
    {
      label: 'InActive',
      value: 'InActive',
    },
  ],
  UniLevelStatusCell: ['Active', 'InActive'],
  UniLevelDeployedStatus: [
    {
      label: 'Active',
      value: 'Active',
    },
    {
      label: 'Pending',
      value: 'Pending',
    },
  ],
  UniLevelPaysUpline: [
    {
      label: 'Yes',
      value: 'Yes',
    },
    {
      label: 'No',
      value: 'No',
    },
  ],

  AutoBillValue: [
    {
      label: 'True',
      value: 'True',
    },
    {
      label: 'False',
      value: 'False',
    },
  ],

  AutoShipValueList: [
    {
      label: 'Days',
      value: 'Days',
    },
    {
      label: 'Months',
      value: 'Months',
    },
    {
      label: 'Years',
      value: 'Years',
    },
  ],

  PriceLevelValuesList: [
    {
      label: 'Sale Price',
      value: 'Sale Price',
    },
    {
      label: 'Affiliate Price',
      value: 'Affiliate Price',
    },
    {
      label: 'Membership Price',
      value: 'Membership Price',
    },
    {
      label: 'Affiliate Membership Price',
      value: 'Affiliate Membership Price',
    },
  ],

  UniLevelBadgeClass: [
    {
      Active: {
        class: 'outline-badge-success',
      },
      InActive: {
        class: 'outline-badge-danger',
      },
      Yes: {
        class: 'outline-badge-success',
      },
      No: {
        class: 'outline-badge-danger',
      },
    },
  ],
  MenuType: [
    {
      label: 'collapse',
      value: 'collapse',
    },
    {
      label: 'item',
      value: 'item',
    },
    {
      label: 'external-link',
      value: 'external-link',
    },
  ],
  promotionAppliedOnList: [
    { value: 'Retail', label: 'Retail' },
    { value: 'Consultant', label: 'Consultant' },
    { value: 'Both', label: 'Both' },
  ],
  selectCreditStatus: 'Select status',

  productCreditStatus: {
    Pending: 'Pending',
    Deleted: 'Deleted',
    Active: 'Active',
  },
  SalesReportType: [
    {
      label: 'Sales By Items',
      value: 'SalesByItems',
    },
    {
      label: 'Sales By Order',
      value: 'SalesByOrder',
    },
    {
      label: 'Sales By Top Affiliate',
      value: 'SalesByTopAffiliate',
    },
    {
      label: 'Top Selling Item By Value',
      value: 'SalesByTopItemValue',
    },
    {
      label: 'Top Selling Item By Qty',
      value: 'SalesByTopItemQty',
    },
    {
      label: 'Sales By Country',
      value: 'SalesByCountry',
    },
  ],
  IwalletMethodReportType: [
    {
      label: 'All',
      value: 'All',
    },
    {
      label: 'Wire',
      value: 'Wire',
    },
    // {
    //   label: 'BitCoin',
    //   value: 'BitCoin',
    // },
    {
      label: 'ACH',
      value: 'ACH',
    },
    {
      label: 'USDC',
      value: 'USDC',
    },
  ],

  Iwallet1099Year: [
    {
      label: '2023',
      value: 2023,
    },
    // {
    //   label: '2024',
    //   value: 2024,
    // },
  ],

  CommissionReportType: [
    {
      label: 'Commission Earned By Periods',
      value: 'CommissionEarnedByPeriods',
    },
    {
      label: 'Commission Paid Out By Periods',
      value: 'CommissionPaidOutByPeriods',
    },
  ],
  ReportType: {
    SalesByItems: 'SalesByItems',
    SalesByOrder: 'SalesByOrder',
    SalesByTopAffiliate: 'SalesByTopAffiliate',
    SalesByTopItemValue: 'SalesByTopItemValue',
    SalesByTopItemQty: 'SalesByTopItemQty',
    CommissionEarnedByPeriods: 'CommissionEarnedByPeriods',
    CommissionPaidOutByPeriods: 'CommissionPaidOutByPeriods',
    SalesByCountry: 'SalesByCountry',
  },
  CustomerType: {
    RetailCustomer: 'RetailCustomer',
    Affiliate: 'Affiliate',
    Ambassador: 'Consultant',
  },
  DeployedStatus: [
    {
      label: 'Paid',
      value: 'Paid',
    },
    {
      label: 'Pending',
      value: 'Pending',
    },
  ],
  orderPaymentOptions: {
    AuthNet: 'AuthNet',
    Manual: 'Manual',
    SendInvoice: 'SendInvoice',
    Net30: 'Net30',
  },
  LeadCollection: {
    CsvFileURL: `${process.env.REACT_APP_BLOB_URL}admin-assets/Sample-freedom-commission.csv`,
  },
  CountryList: ['us', 'ca', 'mx', 'ph', 'gb'],
  PanelBatteryStatus: [
    {
      value: 0,
      label: 'Battery Stable',
    },
    {
      value: 1,
      label: 'Battery Low',
    },
    {
      value: 2,
      label: 'Battery Dead',
    },
  ],
  PanelACPowerStatus: [
    {
      value: 0,
      label: 'AC Power ON',
    },
    {
      value: 1,
      label: 'AC Loss',
    },
  ],
  PaymentGatewayType: {
    NMI: 'NMI',
    Auth: 'Auth'
  }
}
export default dataConstant
